import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useContext, useState } from 'react'
import { FaRegWindowClose } from 'react-icons/fa';
import { CheckOutContext } from '../../Context/CheckOutContext.jsx';

const ReviewModal = ({ visible, onClose, productId }) => {
    const [rate, setRate] = useState('');
    const [comment, setComment] = useState('');
    const { addReview } = useContext(CheckOutContext)

    if (!visible) return null


    const handleCloseModalById = (e) => {
        if (e.target.id === "modal")
            onClose();
    }


    const handleRateChange = (event) => {
        setRate(event.target.value)
    };

    const getComment = (e) => {
        setComment(e.target.value)
    }
    return (
        <div id="modal" onClick={handleCloseModalById} className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="bg-white p-2 rounded w-11/12 sm:w-9/12 lg:w-8/12 relative">
                <button onClick={onClose} className='absolute right-2 text-red-600 hover:text-red-500'><FaRegWindowClose size={24} /></button>
                <h1 className="font-semibold text-center text-xl text-gray-700 my-3">Review Product</h1>
                <hr />
                <div className="flex flex-col my-4">
                    <div className="my-2">
                        <TextField onChange={getComment} name="text" className="w-full" id="filled-basic" label="Review comment" variant="outlined" />
                    </div>
                    <div className="my-2">
                        <FormControl className="w-full">
                            <InputLabel id="demo-simple-select-label">Rate</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={rate}
                                label="Rate"
                                name="rate"
                                onChange={handleRateChange}
                            >
                                <MenuItem value={1}>1 Poor</MenuItem>
                                <MenuItem value={2}>2 Fair</MenuItem>
                                <MenuItem value={3}>3 Good</MenuItem>
                                <MenuItem value={4}>4 Very Good</MenuItem>
                                <MenuItem value={5}>5 Excellent</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <button onClick={() => addReview(productId, comment, rate,onClose)} className="bg-blue-600 p-2 px-8 rounded text-white hover:bg-blue-500 transition">Review</button>
                </div>
            </div>
        </div>
    )
}

export default ReviewModal